export default __webpack_public_path__ + "images/DocumentIcon.8eacf96764be27ad9668d7ccb96a4694.png";